<div>
  <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
    <p>
      {{ "module-assignment.hotkeys.title" | translate }}
    </p>
    <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-15">
      <mat-slide-toggle
        [(ngModel)]="status"
        id="ebasketSalesSetupHotkeys"
        (change)="toggleEbasketSalesSetupHotkeys()"
        [disabled]="action==='view'"
      >
      </mat-slide-toggle>
    </div>
  </div>
  <div
    fxLayout="row wrap"
    fxLayoutGap="20px grid"
    *ngIf="status"
    class="u-margin-top-15 u-margin-bottom-15"
  >
    <div fxFlex="100">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            {{ "module-assignment.hotkeys.title" | translate }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div
            fxLayout="row wrap"
            fxLayoutGap="20px grid"
            class="u-margin-top-15 u-margin-bottom-15"
          >
            <div fxFlex="50">
              <mat-form-field class="mat-block" floatLabel="never">
                <input
                  matInput
                  [placeholder]="'module-assignment.hotkeys.search' | translate"
                  #input
                  (input)="search()"
                />
              </mat-form-field>
            </div>
            <div fxFlex="50">
              <button
                mat-icon-button
                class="pull-right"
                [matTooltip]="'module-assignment.hotkeys.add' | translate"
                matTooltipPosition="above"
                (click)="openAddHotkeyDialog()"
                [disabled]="action==='view'"
              >
                <mat-icon>add_circle</mat-icon>
              </button>
              <button
                mat-icon-button
                class="pull-right"
                [matTooltip]="'module-assignment.hotkeys.add_hotkey_group' | translate"
                matTooltipPosition="above"
                (click)="openAddHotkeyGroupDialog()"
                [disabled]="addGroupShouldEnable() || action==='view'"
              >
                <mat-icon>library_add</mat-icon>
              </button>
            </div>
          </div>
          <div
            fxLayout="row wrap"
            fxLayoutGap="20px grid"
            class="u-margin-top-15 u-margin-bottom-15"
          >
            <div
              fxFlex="100"
              class="table-container"
              [ngStyle]="{'display': 'flex'
              ,'flex-direction': 'column'}"
            >
              <div class="table-scroll" #tableScrollContainer>
                <table
                  mat-table
                  #ebasketHotkeysTable
                  [dataSource]="productDataSource"
                  matSort
                  cdkDropList
                  multiTemplateDataRows
                  (cdkDropListDropped)="drop($event)"
                  [cdkDropListDisabled]="action === 'view'"
                >
                  <ng-container matColumnDef="position">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <!-- {{ "module-assignment.hotkeys.position" | translate }} -->
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{element.position}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                      <mat-checkbox
                        *ngIf="element && !element.isHotKeyGroup"
                        (click)="$event.stopPropagation()"
                        (change)="onCheckboxChange(element, $event)"
                        [checked]="element.checked"
                        [aria-label]="checkboxLabel(element)"
                      >
                      </mat-checkbox>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="expand">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                      <button
                        mat-icon-button
                        (click)="toggleRow(element)"
                        *ngIf="element && element.isHotKeyGroup"
                      >
                        <mat-icon
                          >{{ isExpanded(element) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
                          }}</mat-icon
                        >
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="drag">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" cdkDragHandle>
                      <mat-icon>drag_handle</mat-icon>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="SKU">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ "module-assignment.hotkeys.sku" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.SKU }}</td>
                  </ng-container>
                  <ng-container matColumnDef="displayName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ "module-assignment.hotkeys.displayName" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{element.displayName}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ "module-assignment.hotkeys.action" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <button
                        mat-icon-button
                        [matTooltip]="'module-assignment.hotkeys.edit' | translate"
                        matTooltipPosition="above"
                        (click)="editRow(element,'edit')"
                        [disabled]="action==='view'"
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        [matTooltip]="'module-assignment.hotkeys.view' | translate"
                        matTooltipPosition="above"
                        (click)="editRow(element,'view')"
                      >
                        <mat-icon>remove_red_eye</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        [matTooltip]="'module-assignment.hotkeys.delete' | translate"
                        matTooltipPosition="above"
                        (click)="removeRow(element)"
                        [disabled]="action==='view'"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="productColumns"></tr>
                  <tr mat-row cdkDrag *matRowDef="let row; columns: productColumns;"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: ['expandedDetail']"
                    [class.expanded-row]="isExpanded(row)"
                    [ngClass]="{ 'expandable': !isExpanded(row) }"
                  ></tr>
                  <ng-container matColumnDef="expandedDetail">
                    <td
                      mat-cell
                      *matCellDef="let element"
                      [attr.colspan]="productColumns.length"
                      [hidden]="!isExpanded(element)"
                    >
                      <div class="example-element-detail">
                        <table
                          mat-table
                          [dataSource]="getHotkeysForGroup(element)"
                          matSort
                          matSortDisableClear
                          [matSortActive]="true"
                          class="hotkeysTable"
                          cdkDropList
                          multiTemplateDataRows
                          (cdkDropListDropped)="dropChildHotkeys($event, element)"
                          [cdkDropListDisabled]="action === 'view'"
                        >
                          <tr
                            id="matHeaderRowUser"
                            mat-header-row
                            *matHeaderRowDef="displayedColumnsInternal"
                          ></tr>
                          <tr
                            id="matRowUser"
                            mat-row
                            *matRowDef="let row; columns:displayedColumnsInternal"
                            cdkDrag
                            [cdkDragData]="row"
                          ></tr>
                          <ng-container matColumnDef="drag">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element" cdkDragHandle>
                              <mat-icon>drag_handle</mat-icon>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef>
                              <!-- {{ 'module-assignment.hotkeys.position' | translate }} -->
                            </th>
                            <td mat-cell *matCellDef="let hotkey">{{ hotkey.position }}</td>
                          </ng-container>
                          <ng-container matColumnDef="SKU">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'module-assignment.hotkeys.sku' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let hotkey">{{ hotkey.SKU }}</td>
                          </ng-container>
                          <ng-container matColumnDef="displayName">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'module-assignment.hotkeys.displayName' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let hotkey">{{ hotkey.displayName }}</td>
                          </ng-container>
                        </table>
                      </div>
                    </td>
                  </ng-container>
                </table>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
